import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';
import { useAppContext } from '../../../hooks/useAppContext';
import { updateLeaveStatus } from '../../../services/employeeLeaves';
import { ActionStatus, EmployeeLeave } from '../../../types/employee';
import { AlphaNumericAndCharactersRegex } from '../../../constants/validations';
// import { UserRole } from '../../../types/user';

type LeavesApprovalModalProp = {
    leave: EmployeeLeave;
    showModal: boolean;
    loggedInUserId: string;
    handleClose: () => void;
    handleSearchClick: () => void;
};
// TODO: Better Design and complete Data.
export const LeavesApprovalModal = (prop: LeavesApprovalModalProp) => {
    const { loggedInUserId, leave } = prop;
    const [submitLoading, setSubmitLoading] = useState(false);
    const [error, setError] = useState('');
    const [comments, setComments] = useState('');
    const { triggerSuccess } = useAppContext();

    const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        const value = e.target.value;
        setComments(value);
    };

    const handleSubmit = async (status: 'REQUESTED' | 'APPROVED' | 'REJECTED') => {
        if (!comments) {
            setError('Please add some comment');
        } else if (comments.length > 100) {
            setError('comments too long.');
        } else if (!AlphaNumericAndCharactersRegex.test(comments)) {
            setError('Comments should only contain alphanumeric characters only');
        } else {
            setSubmitLoading(true);
            try {
                await updateLeaveStatus(prop.leave.uuid, prop.leave.employeeId, comments, status);
                setSubmitLoading(false);
                prop.handleClose();
                setComments('');
                triggerSuccess(`Leave status updated`);
                prop.handleSearchClick();
            } catch (_e) {
                setSubmitLoading(false);
                prop.handleClose();
                setComments('');
            }
        }
    };
    const approverKey = leave.leaveApprovers.findIndex((approver) => approver.approverId === loggedInUserId);

    return (
        <Modal centered={true} show={prop.showModal} onHide={() => prop.handleClose()}>
            <Modal.Header>
                <Modal.Title>
                    <h3 className="ms-2">Employee Leave Approval</h3>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="p-3">
                    {approverKey != -1 &&
                        (leave.leaveApprovers[approverKey].approvalStatus === ActionStatus.APPROVED ||
                            leave.leaveApprovers[approverKey].approvalStatus === ActionStatus.REJECTED) && (
                            <div className="alert alert-danger alert-dismissible fine-print" role="alert">
                                <div className="alert-message">
                                    <p className="alert-heading">
                                        {' '}
                                        <FontAwesomeIcon className="icons" size="xl" icon={icon({ name: 'warning' })} />{' '}
                                        <strong>Already {leave.leaveApprovers[approverKey].approvalStatus}</strong>
                                    </p>
                                    <p className="mb-1">
                                        You have already {leave.leaveApprovers[approverKey].approvalStatus} the leave for
                                        this employee.
                                    </p>
                                    <p className="mb-1">
                                        If you are trying to update the previously{' '}
                                        {leave.leaveApprovers[approverKey].approvalStatus} leave it will overwrite the
                                        previous status.
                                    </p>
                                    <p className="mb-1">
                                        Employee may or may not be aware of this action, please reach out to employee to
                                        inform him/her about this new update.
                                    </p>
                                </div>
                            </div>
                        )}

                    <h4>Comments</h4>
                    <div className="">
                        {submitLoading ? (
                            <div key={0} className="row">
                                <div className="col-sm-12 mt-2 mb-2 text-center">
                                    <div className="spinner-border text-primary me-2" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <>
                                <textarea
                                    rows={5}
                                    className={`form-control form-control-lg mb-3 ${error ? 'is-invalid' : ''}`}
                                    name="comments"
                                    value={comments}
                                    onChange={handleChange}
                                />
                                {error && <div className="invalid-feedback mb-3">{error}</div>}
                                <div className="text-end mt-2">
                                    <button
                                        type="button"
                                        className="btn btn-danger me-2"
                                        onClick={() => handleSubmit('REJECTED')}
                                    >
                                        Reject
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-success ms-2"
                                        onClick={() => handleSubmit('APPROVED')}
                                    >
                                        Approve
                                    </button>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={() => prop.handleClose()}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};
